export default __webpack_public_path__ + "static/media/Sample Banner.9e6493af.png";